export class EntityLineRevisionChange {
  entityId = '';
  lineId = '';
  previousRevisionId = 0;
  currentRevisionId = 0;
  previousProductNumber = '';
  currentProductNumber = '';
  previousQuantity = 0;
  currentQuantity = 0;
  changeDescription = '';
}
